import React, {useEffect, useState} from "react";
import {Formik} from "formik";
import PaymentUserInformation from "./PaymentUserInformation";
import BankAccountDetails from "./BankAccountDetails";
import BankAccountList from "./BankAccountList";
import PaymentNotes from "./PaymentNotes";
import {Button} from "../../formInputs";
import {Grid} from "@material-ui/core";
import * as Yup from "yup";
import {useActions} from "../../../actions";
import * as PaymentActions from "../../../actions/payment";
import {usePolicyContext} from "./PolicyContext";
import moment from "moment";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers";
import numeral from "numeral";
import Typography from "@material-ui/core/Typography";
import {bankInitialValues, bankSchema, paymentInitialValues, paymentSchema} from "../../../model/payment";
import GenericDialog, { GenericDialogProps } from "../../dialog/GenericDialog";
import PaymentHistoryDetailsData from "./PaymentHistoryDetails";
import {isDebug, unmaskCurrency} from "../../../utils/commonUtils";
import {isAdmin} from "../../navigation/AdminNavigation";
import {ClientSplitAmountType, sumClientSplitAmount} from "./index";


interface EpayProps {
    handleClose: Function;
    paymentMethod?: string | number;
    source?:string
}

function EpayPaymentInformation(props: EpayProps) {
    const {handleClose, paymentMethod = 3, source} = props;
    let buttonLabel = "Send Payment";
    if (paymentMethod === 4) {
        buttonLabel = "Set Up Monthly ePay";
    }
    console.log("Payment method===>", paymentMethod)
    const payment = useActions(PaymentActions);
    const profile = useSelector((state: RootState) => state.profile);
    console.log("Profile Details: ", profile);
    const {user} = useSelector((state: RootState) => state.auth);
    const {policy, refetchPolicy}: any = usePolicyContext();
    const [paymentTimeTable, setPaymentTimeTable] = useState({});
    const [policyNumber, setPolicyNumber] = useState("");
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [initialValues, setIntialValues] = useState(paymentInitialValues);
    const [schema, setSchema] = useState<any>({...paymentSchema, ...bankSchema});
    const paymentFrequency: string = profile.client && profile.client.clientPolicies && profile.client.clientPolicies[0] && profile.client.clientPolicies[0].paymentFrequency || "annual";
    const tranche = profile.client && profile.client.tranche && profile.client.tranche;
    const [agreementText, setAgreementText] = useState('By clicking "Send Payment", I authorize NIW to debit my account. I understand that this payment includes a $3.00 fee assessed by ePay.');
    let [showBreakDown, setShowBreakDown] = useState(false);
    const [paymentHistoryDetails, setPaymentHistoryDetails]:any = React.useState({ });
    const [firstMonthPayment, setFirstMonthPayment] = useState(0);
    const isFromAddPayment = "AddEpayPayment" == source
    const dialogProps: GenericDialogProps = {
        "aria-labelledby": "customized-dialog-title",
        fullWidth: true,
        maxWidth: "sm",
        content: (
                <>
                    <PaymentHistoryDetailsData showTrustee={false} paymentHistoryDetails={paymentHistoryDetails}/>
                    <Grid className="displayF" style={{justifyContent:"end",gap:5}} >
                        <Button label={"Edit Information"} color="primary" size="small" variant="contained" onClick={()=>{setShowBreakDown(false)}} />
                        <Button label={"Confirm and Close"} type="submit" form="paymentSubmission" color="primary" size="small" variant="contained" />
                    </Grid>
                </>
        ),
        dividers: true,
        onClose: ()=>{
            setShowBreakDown(false);
        },
        open: showBreakDown,
        title: "Payment Details",
    };
    useEffect(() => {
        if (policy && policy.policyNumber) {
            const timeTable = paymentFrequency === "annual" ? policy.paymentTimetableAnnual : policy.paymentTimetableMonthly;
            let newPaymentAmount = timeTable.nextPayment && timeTable.nextPayment.amount && sumClientSplitAmount(timeTable.nextPayment.amount).amountLessMerchant;
            let recurringPaymentDate = timeTable && timeTable.nextPayment && moment(timeTable.nextPayment.date).format("MM/DD/YYYY") || "";
            if (paymentMethod === 4 && timeTable && timeTable.switchRecurring) {
                newPaymentAmount = timeTable.switchRecurring && timeTable.switchRecurring[0] && sumClientSplitAmount(timeTable.switchRecurring[0].amount).amountLessMerchant;
                recurringPaymentDate = timeTable.switchRecurring[0].date ? moment(timeTable.switchRecurring[0].date).format("MM/DD/YYYY") : "";
                setAgreementText('By clicking "Set Up Monthly ePay", I authorize NIW to debit my account ' + numeral(sumClientSplitAmount(timeTable.switchRecurring[0]).totalAmount).format("$0,0.00") + ' now and set up monthly payments thereafter of ' + numeral(newPaymentAmount).format("$0,0.00") + ' until my policy is paid in full. I understand that each months ePay payment includes a $3.00 fee assessed by ePay.');

            }
            let formValues = {...paymentInitialValues, ...bankInitialValues};
            if (policy.paymentMethods && policy.paymentMethods.length > 0) {
                formValues = paymentInitialValues;
                setSchema({...paymentSchema});
            }
             // need to manage this state if isFromAddPayment is true
            setPaymentHistoryDetails(timeTable.nextPayment)
            setFirstMonthPayment(timeTable.switchRecurring && timeTable.switchRecurring[0] && sumClientSplitAmount(timeTable.switchRecurring[0].amount).amountLessMerchant)
            formValues.payerEmail = profile.email;
            formValues.payerFirstName = profile.firstName;
            formValues.payerLastName = profile.lastName;
            formValues.paymentAmount = newPaymentAmount;
            formValues.trancheNumber = tranche ? tranche.trancheNumber : "";
            formValues.fundingDate = tranche ? moment(tranche.projectFundingDate).format("MM/DD/YYYY") : "";
            formValues.recurringPayment = paymentMethod === 4 ? "Monthly" : paymentFrequency.charAt(0).toUpperCase() + paymentFrequency.slice(1);
            formValues.recurringPaymentDate = recurringPaymentDate;
            setIntialValues(formValues);
            setPaymentTimeTable(timeTable);
            setPolicyNumber(policy.policyNumber);
            setPaymentMethods(policy.paymentMethods);

            isDebug() && console.info({isFromAddPayment, newPaymentAmount, paymentAmount: formValues.paymentAmount});
        }
    }, [policy]);
    const EpaySchema = Yup.object().shape(schema);
    const submitFormik = async (values: any, actions: any) => {
        // need to make it false In case of isFromAddPayment is true otherwise no need of it
        setShowBreakDown(false)
        let paymentMethodId = values.paymentMethodId;
        const paymentMethodPayload = {
            policyNumber: policyNumber,
            emailAddress: values.payerEmail,
            accountHolder: values.payerFirstName,
            bankName: values.bankName,
            accountType: values.bankAccountType,
            routingNumber: values.routingNumber,
            accountNumber: values.accountNumber,
        };
        if (!paymentMethodId) {
            const paymentMethod = await payment.addPaymentMethod(paymentMethodPayload);
            paymentMethodId = paymentMethod && paymentMethod.paymentMethods.length > 0 && paymentMethod.paymentMethods[0].recordKey;
        }
        const clientName: string = values.payerFirstName + " " + values.payerLastName;
        let paymentPayload: any = {
            policyNumber: policy.policyNumber,
            paymentMethodId: paymentMethodId,
            payerName: clientName,
            payerEmail: values.payerEmail
        };
        const merchantPayment = {amount: 3, type: ClientSplitAmountType.Merchant};
        if (paymentMethod === 4) {
            paymentPayload.type = "AnnualToMonthly";
            paymentPayload.emailPayload = {
                amount: numeral(values.paymentAmount).format("$0,0.00"),
                recurringAmount: numeral(firstMonthPayment).format("$0,0.00") ,
                dueDate: moment(values.recurringPaymentDate).format('MMMM DD ') + " every " + (paymentFrequency === "monthly" ? "month" : "year")
            };
            isDebug() && console.info("createPaymentSchedule", paymentPayload)
            await payment.createPaymentSchedule(paymentPayload);
        } else {
            paymentPayload.clientPayment = {
                date: moment().format("YYYY-MM-DD"),
                type: "ePay",
                details: values.notes,
                processedBy: clientName,
                amount: [
                    {amount: numeral(values.paymentAmount).value(), type: ClientSplitAmountType.Premium},
                    merchantPayment
                ],
            };
            isDebug() && console.info("createPayment", paymentPayload);
            await payment.createPayment(paymentPayload);
        }
        actions.setSubmitting(false);
        await refetchPolicy();
        actions.resetForm();
        handleClose();
    };

    return (
        <>
            <Typography variant="body1" component="strong" className="mt20 floatLeft w100 mb0">
                Payment Information
            </Typography>
            <Formik
                initialValues={initialValues}
                onSubmit={submitFormik}
                enableReinitialize={true}
                validationSchema={EpaySchema}
            >
                {({
                      values,
                      handleSubmit,
                      isSubmitting,
                  }) =>
                    (
                        <form id="paymentSubmission" onSubmit={handleSubmit}>
                            <PaymentUserInformation paymentMethod={paymentMethod}  source={"servicing"}/>
                            <span className="hLine"/>
                             {isFromAddPayment && <Typography variant="body1" className="mb0">An additional $3 ePay process charge will be  added to your contribution amount.</Typography>}
                            <span className="hLine"/>
                            {
                                paymentMethods && paymentMethods.length > 0 ?
                                        <BankAccountList/> :
                                        <BankAccountDetails/>
                            }
                            <PaymentNotes agreementText={agreementText}/>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {isFromAddPayment ? <Button
                                        label={buttonLabel}
                                        className="floatRight mb20"
                                        type="button"
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        disabled={isSubmitting || !!(user && user.accessType === "client" && user.demoClientId) }
                                        loading={isSubmitting}
                                        onClick={() =>  {
                                        paymentHistoryDetails.amount[0].amount = Number(unmaskCurrency(values.paymentAmount.toString())) - (paymentHistoryDetails.amount[1].amount || 0)
                                        setPaymentHistoryDetails(paymentHistoryDetails)
                                        setShowBreakDown(true)}}
                                    />:<Button
                                        label={buttonLabel}
                                        className="floatRight mb20"
                                        type="submit"
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        disabled={!isAdmin(user) ? isSubmitting : true}
                                        loading={isSubmitting}
                                    />
                                    }

                                    <Button
                                        label="Cancel"
                                        className="floatRight mb20"
                                        onClick={() => handleClose()}
                                        color="primary"
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    )
                }
            </Formik>
            {
                paymentHistoryDetails &&
                <GenericDialog {...dialogProps} />
            }
        </>
    );
}

export default EpayPaymentInformation;